import { useState, useMemo } from 'react';

const useQueryFilters = ({ queryData, queryResolutionTypes }) => {
    const [queryFilters, setQueryFilters] = useState({
        searchTerm: '', roleDepartment: '', resolutionType: '', supplier: ''
    });

    const queryDeptOptions = useMemo(() => {
        if (!queryData) return [];
        return [...new Set(queryData.map(item => item.roledepartment).filter(Boolean))].sort().map(d => ({ value: d, label: d }));
    }, [queryData]);

    const querySupplierOptions = useMemo(() => {
        if (!queryData) return [];
        return [...new Set(queryData.map(item => item.providerName).filter(Boolean))].sort().map(s => ({ value: s, label: s }));
    }, [queryData]);

    const queryResolutionTypeOptions = useMemo(() => {
        return queryResolutionTypes.map(type => ({ value: type.id.toString(), label: type.resolution }));
    }, [queryResolutionTypes]);

    return {
        queryFilters,
        setQueryFilters,
        queryDeptOptions,
        querySupplierOptions,
        queryResolutionTypeOptions,
    };
};

export default useQueryFilters;
